import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { MultiLangText, Input } from '@platform/base';
import CompMeta from '../../meta/LowCodeComponents/MultiLangText';
const sourceTypeEnum = ["designer", "runtime"];
/**
 * @class NCMultiLangText
 * @column 1
 * @compType 1
 * @canAppend false
 * @path LowCodeComponents.NCMultiLangText
 * @label 多语文本
 *
 */
class NCMultiLangText extends Component {
    constructor(props) {
        super(props);
    }
    static propTypes = {
        /**
       * @title 区域编码
       * @description 组件标识
       */
        moduleId: PropTypes.string.isRequired,
        // /**
        //  * @title 来源类型
        //  * @description 来源类型
        //  * @enumNames ['设计器', '运行时']
        //  */
        // sourceType: PropTypes.oneOf(sourceTypeEnum),
        /**
         * @title className
         * @description 样式
         */
        className: PropTypes.string,
        /**
         * @title 自动化Id
         * @description 自动化Id
         */
        fieldid: PropTypes.string,
        /**
         * @title 自动聚焦
         * @description 自动聚焦
         */
        autoFocus: PropTypes.bool,
        /**
         * @title 最大长度
         * @description 最大长度
         */
        maxLength: PropTypes.number,
        /**
         * @title renderInTable
         * @description renderInTable
         */
        renderInTable: PropTypes.bool,
        /**
         * @title 自动聚焦
         * @description 自动聚焦
         */
        autoFocus: PropTypes.bool,

    }
    static getCompMeta = () => {
        return CompMeta;
    }
    static defaultProps = {
        sourceType: "designer"
    }

    render() {
        let { sourceType, ...others } = this.props;
        return (
            <Fragment>
                {sourceType === "designer" ? <Input {...others} /> : <MultiLangText {...others} />}
            </Fragment>
        )
    }
}

export default NCMultiLangText;
